import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import {
  routePattern,
  setUsageEventPage,
  startUsageEventFlushing,
  trackEvent,
} from '@/shared/lib';

interface Props {
  organizationId: string | undefined;
}

export function UsageTracker({ organizationId }: Props) {
  const { pathname } = useLocation();
  const params = useParams();
  const page = routePattern(pathname, params);

  useEffect(() => startUsageEventFlushing(), []);

  useEffect(() => {
    if (page.includes('*')) {
      return;
    }

    setUsageEventPage(page);
    trackEvent('view', 'open');
  }, [page, organizationId]);

  return null;
}
